import { render, staticRenderFns } from "./header2.vue?vue&type=template&id=6c1267b8&scoped=true&"
import script from "./header2.vue?vue&type=script&lang=js&"
export * from "./header2.vue?vue&type=script&lang=js&"
import style0 from "./header2.vue?vue&type=style&index=0&id=6c1267b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1267b8",
  null
  
)

export default component.exports